import { createReducer } from '@reduxjs/toolkit'
import { createBuilder } from 'packages/redux-toolkit'

import { getAllPromoLogs } from './actions'

interface PromoLogsState {
  list: {
    loading: boolean
    items: string[]
  }
}

const initialState: PromoLogsState = {
  list: {
    loading: false,
    items: [],
  },
}

export const promoLogsReducer = createReducer(initialState, (builder) => {
  createBuilder(builder)
    .addCase(getAllPromoLogs.pending, (state) => {
      state.list.loading = true
    })
    .addCase(getAllPromoLogs.rejected, (state) => {
      state.list.loading = false
    })
    .addCase(getAllPromoLogs.fulfilled, (state, { payload }) => {
      state.list.loading = false
      state.list.items = payload.logFileNames
    })
})
